/**
 * Returns true when the schedule should be read-only (currently: org view).
 *
 * Disabled for now — enable by returning `isOrgViewActive` once the org
 * schedule read-only UX is validated.
 *
 * import { useOrgScheduleFilters } from './useOrgScheduleFilters';
 * const { isOrgViewActive } = useOrgScheduleFilters();
 * return isOrgViewActive;
 */
export function useScheduleReadOnly(): boolean {
  return false;
}
